"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var semantic_ui_react_1 = require("semantic-ui-react");
var he_1 = __importDefault(require("he"));
var PostPreview_1 = __importDefault(require("./PostPreview"));
require("./PostList.scss");
var placeholder_png_1 = __importDefault(require("../../../../staticAssets/images/placeholder.png"));
var swiper_1 = __importStar(require("swiper"));
var react_2 = require("swiper/react");
require("swiper/swiper.scss");
require("swiper/components/navigation/navigation.scss");
require("swiper/components/scrollbar/scrollbar.scss");
require("swiper/components/pagination/pagination.min.css");
var PostsList = /** @class */ (function (_super) {
    __extends(PostsList, _super);
    function PostsList(props) {
        swiper_1.default.use([swiper_1.Navigation, swiper_1.Scrollbar, swiper_1.Pagination]);
        return _super.call(this, props) || this;
    }
    PostsList.prototype.render = function () {
        var _a = this.props, posts = _a.posts, clickHandler = _a.clickHandler;
        var pageName = window.location.pathname;
        //TODO : Maps warning
        return ((0, jsx_runtime_1.jsx)(semantic_ui_react_1.Grid, { children: pageName != '/' ?
                (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Grid, { children: posts.map(function (postInfo) {
                        var id = postInfo.id, date_gmt = postInfo.date_gmt, title = postInfo.title, slug = postInfo.slug, content = postInfo.content, _embedded = postInfo._embedded, details = postInfo.details, excerpt = postInfo.excerpt, read_time = postInfo.read_time, acf = postInfo.acf, type = postInfo.type;
                        var author = _embedded.author;
                        var rating = details.rating, post_comments_number = details.post_comments_number;
                        var rendered = title.rendered;
                        var post_subtitle = acf.post_subtitle;
                        var featured_image = postInfo._embedded['wp:featuredmedia'] ? postInfo._embedded['wp:featuredmedia'][0].source_url : placeholder_png_1.default;
                        return ((0, jsx_runtime_1.jsx)(semantic_ui_react_1.Grid.Row
                        // key={id}
                        , __assign({ 
                            // key={id}
                            className: "post-preview", onClick: function () { return clickHandler(postInfo); } }, { children: (0, jsx_runtime_1.jsx)(PostPreview_1.default, { title: he_1.default.decode(rendered), subTitle: post_subtitle, content: he_1.default.decode(content.rendered), time: date_gmt, name: author[0].name, slug: author[0].slug, url: slug, articleId: id, avatarURL: author[0].avatar_urls[96], rating: rating, excerpt: excerpt.rendered, comments: post_comments_number, featured_image: featured_image, author: _embedded, read_time: read_time, type: type }) })));
                    }) }) :
                (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Grid, __assign({ className: "check1" }, { children: (0, jsx_runtime_1.jsx)(react_2.Swiper, __assign({ slidesPerView: 3, spaceBetween: 30, breakpoints: {
                            1200: {
                                freemode: true,
                                slidesPerView: 3,
                                spaceBetween: 30,
                            },
                            768: {
                                freemode: true,
                                slidesPerView: 2,
                                spaceBetween: 30,
                            },
                            640: {
                                freemode: true,
                                slidesPerView: 1,
                                spaceBetween: 20,
                            },
                            320: {
                                freemode: true,
                                slidesPerView: 1,
                                spaceBetween: 20,
                            }
                        }, className: "mySwiper", slideToClickedSlide: true, onSwiper: function (swiper) { return console.log(swiper); }, onSlideChange: function () { return console.log('slide change'); } }, { children: posts.map(function (postInfo) {
                            var id = postInfo.id, date_gmt = postInfo.date_gmt, title = postInfo.title, slug = postInfo.slug, _embedded = postInfo._embedded, details = postInfo.details, excerpt = postInfo.excerpt, acf = postInfo.acf, read_time = postInfo.read_time, type = postInfo.type;
                            var author = _embedded.author;
                            var rating = details.rating, post_comments_number = details.post_comments_number;
                            var rendered = title.rendered;
                            var post_subtitle = acf.post_subtitle;
                            var featured_image = postInfo._embedded['wp:featuredmedia'] ? postInfo._embedded['wp:featuredmedia'][0].source_url : placeholder_png_1.default;
                            return ((0, jsx_runtime_1.jsx)(react_2.SwiperSlide, { children: (0, jsx_runtime_1.jsx)(PostPreview_1.default, { title: he_1.default.decode(rendered), subTitle: post_subtitle, time: date_gmt, name: author[0].name, slug: author[0].slug, url: slug, articleId: id, avatarURL: author[0].avatar_urls[96], rating: rating, excerpt: excerpt.rendered, comments: post_comments_number, featured_image: featured_image, author: _embedded, type: type, read_time: read_time, ratingModalTrigger: ratingDisplayTrigger }) }));
                        }) })) })) }));
    };
    return PostsList;
}(react_1.Component));
exports.default = PostsList;
